/**
 * PullToRefreshContainer — DISATTIVATO (Phase 43.52)
 *
 * Il pull-to-refresh custom è stato rimosso per garantire scroll nativo
 * fluido su iOS PWA. Questo componente resta come passthrough trasparente
 * per non rompere i chiamanti esistenti.
 */
export default function PullToRefreshContainer({ children }) {
  return (
    <div data-testid="pull-to-refresh" className="relative">
      {children}
    </div>
  );
}
